exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".image-content{position:relative;display:block;width:100%;height:100%;border-radius:6px;overflow:hidden;text-align:left}.image-content>img{position:relative;height:auto;width:100%;top:50%;transform:translateY(-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6aa562c1","scoped":false,"hasInlineConfig":true}!./src/components/image-content/image-content.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-6aa562c1","scoped":false,"hasInlineConfig":true}!./src/components/image-content/image-content.css
// module chunks = index